import React from 'react';
import arrowImg from 'assets/chevron-left-teal.svg';
import styles from './style.module.css';
import PropTypes from 'prop-types';
import { BannerMessage } from 'components';

const backButton = (onBackClick, underContent, pushTop) => (
  <div
    id="goBackButton"
    tabIndex="0"
    onKeyPress={(event) => (event.key === 'Enter' ? onBackClick() : null)}
    className={`${styles.goBack} ${!underContent ? styles.goBackAbsolute : ''} ${pushTop ? styles.pushTop : ''}`}
    onClick={onBackClick}>
    <img alt="back arrow" src={arrowImg} />
    <div>Back</div>
  </div>
);

const BackPage = ({ onBackClick, children, bpmd, bplg, underContent = true, pushTop = false }) => (
  <div className={`coop-l-container genericSpacer ${styles.grid}`}>
    {!underContent && backButton(onBackClick, underContent)}
    <div className={`coop-l-medium-${bpmd} coop-l-large-${bplg} ${styles.gridContent}`}>
      <BannerMessage />
      {children}
      {underContent && <div>{backButton(onBackClick, underContent, pushTop)}</div>}
    </div>
  </div>
);

BackPage.propTypes = {
  bpmd: PropTypes.string.isRequired,
  bplg: PropTypes.string.isRequired,
};

BackPage.defaultProps = {
  bpmd: '8',
  bplg: '6',
};

export default BackPage;
